import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:5000/api';

const api = axios.create({
    baseURL: API_URL,
});

api.interceptors.request.use(config => {
    const stored = localStorage.getItem('auth');
    if (stored && config.headers) {
        try {
            const { token } = JSON.parse(stored);
            if (token) config.headers.Authorization = `Bearer ${token}`;
        } catch {
            localStorage.removeItem('auth');
        }
    }
    return config;
});

api.interceptors.response.use(
    response => response,
    error => {
        if (error?.response?.status === 401 && localStorage.getItem('auth')) {
            window.dispatchEvent(new Event('admin-auth-expired'));
        }
        return Promise.reject(error);
    },
);

export default api;
